<div class="waec-page-header">
  <img class="waec-page-header-image" src="/assets/icons/Assets_Support.svg" alt="Highighted_Access" />
  <h3 class="waec-page-header-text">{{'GENERAL.SUPPORT' | translate}}</h3>
</div>

<div class="page-container" nz-row>
  <div class="accountProfile">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <nz-breadcrumb class="breadcrumb">
        <nz-breadcrumb-item class="sub-header-text">
          <a [routerLink]="[pageRoutes.enquiry.ticketsListing]">{{'GENERAL.ALL_TICKETS' | translate}}</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item class="sub-header-text">{{'ENQUIRY.TICKET_CATEGORY.OPEN_TICKET' |
          translate}}</nz-breadcrumb-item>
      </nz-breadcrumb>

      <div nz-row nz-justify="space-between" class="parent-container">
        <!-- CATEGORIES -->
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="p-16">
          <nz-row>
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
              <h3 class="waec-card-header-text">
                {{'ENQUIRY.TICKET_CATEGORY.OPEN_TICKET_PROMPT' | translate}}
              </h3>
              <p class="sub-header-text">
                {{'ENQUIRY.TICKET_CATEGORY.OPEN_TICKET_SUBTEXT' | translate}}
              </p>
            </div>
          </nz-row>

          <nz-row class="categories-row">
            <div nz-col [nzSpan]="24" class="category-grid">
              <div class="category-cell" *ngFor="let category of ticketCategories"
                (click)="onSelectCategory(category)" [ngClass]="[
                  category.name.toLowerCase() == ticketTypes.Refund.toLowerCase() ? 'display-none' : '',
                  category.name.toLowerCase() == ticketTypes.Ticket.toLowerCase() ? 'display-none' : '',
                  ((category.name.toLowerCase() == ticketTypes.Access.toLowerCase() || category.name.toLowerCase() == ticketTypes.Share.toLowerCase()) && this.userType ==  userTypes.VERIFIER) ? 'display-none' : '',
                  (category.name.toLowerCase() == ticketTypes.Confirmation.toLowerCase() && this.userType == userTypes.USER) ? 'display-none' : ''
                ]">
                <div class="category" [ngClass]="[category.onPanelfocus ? 'category_active' : '']">
                  <svg-icon nz-tooltip [nzTooltipTitle]="category.name" [src]="category.icon" class="defaultSVG"
                    [svgClass]="onPanelFocus" [applyClass]="true"></svg-icon>
                  <p class="category-text">{{ translateCategory(category.name) }}</p>
                </div>
              </div>
            </div>

            <div nz-col [nzSpan]="24">
              <form [formGroup]="searchForm">
                <nz-form-label [nzSpan]="6" nzFor="title" nzRequired>{{'ENQUIRY.TICKET_CATEGORY.TITLE' |
                  translate}}</nz-form-label>
                <nz-input-group [nzSuffix]="suffixIconSearch">
                  <input type="text" nz-input id="title"
                    placeholder="{{'ENQUIRY.TICKET_CATEGORY.TICKET_FORM_TITLE_PLACEHOLDER' | translate}}"
                    [readonly]="disableField" formControlName="search" (keyup)="onSearchTitle($event)" />
                </nz-input-group>
                <ng-template #suffixIconSearch>
                  <span nz-icon nzType="search"></span>
                </ng-template>
              </form>

              <div *ngIf="resultNotFound" class="not-found">
                <p>
                  <i> {{'ENQUIRY.TICKET_CATEGORY.TICKET_SEARCH_NOT_FOUND' | translate}}</i>
                </p>

                <a (click)="openModal()" class="open-modal-text"><i>{{'ENQUIRY.TICKET_CATEGORY.RAISE_TICKET' |
                    translate}}</i>
                </a>
              </div>

              <div nz-col [nzSpan]="24" class="faq-wrapper" *ngIf="faqQuestions?.length">
                <nz-collapse nzGhost>
                  <nz-collapse-panel #faqAnswer *ngFor="let faq of faqQuestions" [nzHeader]="faq.question"
                    [nzActive]="faq.active" (nzActiveChange)="onActivatePanel(faqAnswer)">
                    <p [innerHTML]="faq.answer" class="faq-answer"></p>
                  </nz-collapse-panel>
                </nz-collapse>
                <br />
                <a (click)="openModal()" class="open-modal-text"><i>{{'ENQUIRY.TICKET_CATEGORY.RAISE_TICKET' |
                    translate}}</i>
                </a>
              </div>
            </div>
          </nz-row>
        </div>
      </div>
    </nz-card>
  </div>
</div>

<!-- TICKET CATEGORY MODAL -->
<nz-modal [nzStyle]="{ top: '20px' }" [nzMask]="true" nzMaskClosable="false" nzWidth="900px" nzClosable="true"
  [(nzVisible)]="ticketCategoryVisibility" nzTitle="{{'ENQUIRY.TICKET_CATEGORY.OPEN_TICKET_MODAL_TITLE' | translate}}"
  [nzContent]="modalContentUserVerification" (nzOnCancel)="closeModal()">
  <ng-template #modalContentUserVerification>
    <support-modal [ticketCategory]="selectedCategory" [userType]="userType" [title]="search"
      (successResponse)="closeModal()"></support-modal>
  </ng-template>
  <div *nzModalFooter></div>
</nz-modal>